export default __webpack_public_path__ + "static/media/photo--sm--109.9554408b.jpg";